import { create } from "zustand";

const useAppStore = create((set) => ({
  coords: null,
  setCoords: (coords) => set(() => ({ coords })),
}));

export default useAppStore;
